import React from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom'

import PrivateRoute from './components/privateRoute';
import Home from './pages/home.js';
import Login from './pages/login.js';
import ForgotPass from './pages/forgotPass.js';
import SignUp from './pages/signUp.js';
import ChangePass from './pages/changePass.js';
import MainScreenUser from './pages/mainScreenUser.js';
import NotFound from './components/notFound';
import VideoScreen from './pages/videoScreen';
import CoursePage from './pages/coursePage';
import FilesPage from './pages/filesPage';

import LimitRoute from './components/limitRoute';

export default function Routes() {
    return (
        <BrowserRouter>
            <Switch>
                <LimitRoute path='/' exact component={Home}/>
                <LimitRoute path='/login' exact component={Login}/>
                <LimitRoute path='/signup' exact component={SignUp}/>
                <LimitRoute path='/forgotpassword' exact component={ForgotPass}/>
                <LimitRoute path='/changepassword' exact component={ChangePass}/>
                <PrivateRoute path='/video' exact component={VideoScreen}/>
                <PrivateRoute path='/home' exact component={MainScreenUser}/>
                <Route path='/files' exact component={FilesPage}/>
                <LimitRoute path='/course/:courseName' exact component={CoursePage}/>
                <PrivateRoute  component={NotFound}/>
            </Switch>
        </BrowserRouter>
    )
};
